<template>
  <el-config-provider :locale="locale"> </el-config-provider>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
export default defineComponent({
  components: {
    ElConfigProvider,
  },
  setup() {
    return {
      locale: zhCn,
    }
  },
})
</script>

<style lang="scss" scoped>
#app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
:deep(.el-table--striped .el-table__body tr.el-table__row--striped td) {
	background: #def1fa !important;
}
:deep(.el-drawer__header) {
  margin-bottom: 10px;
  color: #f56c6c;
}
:deep(.el-drawer__body) {
  margin: 10px;
}
/* 修改滚动条的宽度和背景色 */
:deep(.el-table__body-wrapper::-webkit-scrollbar) {
  width: 15px; /* 宽度 */
  background-color: #f9f9f9; /* 背景色 */
}
 
/* 修改滚动条滑块的样式 */
:deep(.el-table__body-wrapper::-webkit-scrollbar-thumb) {
  border-radius: 15px;
  background-color: #b41616;
}
 
/* 修改滚动条滑块hover样式 */
:deep(.el-table__body-wrapper::-webkit-scrollbar-thumb:hover) {
  background-color: #d23535;
}
::-webkit-scrollbar {
  width: 6px !important;
  height: 6px;
  cursor: pointer;
  margin: 0 !important;
  padding: 0 !important;
}
::-webkit-scrollbar-track {
  background-color: #f6f6f6;
  box-shadow: none;
  cursor: pointer;
  margin: 0 !important;
  padding: 0 !important;
}
::-webkit-scrollbar-button {
  display: block;
  background-color: #f6f6f6;
  width: 0px;
  cursor: pointer;
  margin: 0 !important;
  padding: 0 !important;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(87, 193, 255, 0.5);
  border-radius: 3px;
  cursor: pointer;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
